export type ThemeType = 'classic' | 'blue' | 'green' | 'yellow' | 'pink' | 'minimalist';

interface ThemeConfig {
  accentColor: string;
  backgroundColor: string;
  textColor: string;
  titleColor: string;
  subtitleColor: string;
  buttonColor: string;
  iconColor: string;
  headerBackground: string;
  headerShadow: string;
  titleGradient: string;
  dividerColor: string;
  menuBackground: string;
  menuTextColor: string;
  menuItemColor: string;
  cardBackground: string;
  cardShadow: string;
  cardOverlayGradient: string;
  cardOverlayTextColor: string;
  favoriteColor: string;
}

export const themeConfigs: Record<ThemeType, ThemeConfig> = {
  classic: {
    accentColor: '#7B2CBF',
    backgroundColor: '#121212',
    textColor: '#7B2CBF',
    titleColor: '#7B2CBF',
    subtitleColor: '#B0B0B0',
    buttonColor: '#7B2CBF',
    iconColor: '#FFFFFF',
    headerBackground: 'rgba(0,0,0,0.2)',
    headerShadow: '0 2px 4px rgba(0,0,0,0.1)',
    titleGradient: 'linear-gradient(45deg, #7B2CBF, #9D50BB)',
    dividerColor: 'rgba(255,255,255,0.1)',
    menuBackground: '#1E1E1E',
    menuTextColor: '#FFFFFF',
    menuItemColor: '#FFFFFF',
    cardBackground: '#1E1E1E',
    cardShadow: '0 1px 3px rgba(0,0,0,0.2)',
    cardOverlayGradient: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
    cardOverlayTextColor: '#FFFFFF',
    favoriteColor: '#7B2CBF',
  },
  blue: {
    accentColor: '#1E88E5',
    backgroundColor: '#E3F2FD',
    textColor: '#0D47A1',
    titleColor: '#1565C0',
    subtitleColor: '#1976D2',
    buttonColor: '#1E88E5',
    iconColor: '#0D47A1',
    headerBackground: 'rgba(30,136,229,0.1)',
    headerShadow: '0 2px 4px rgba(13,71,161,0.1)',
    titleGradient: 'linear-gradient(45deg, #1E88E5, #64B5F6)',
    dividerColor: '#1E88E5',
    menuBackground: '#FFFFFF',
    menuTextColor: '#0D47A1',
    menuItemColor: '#1565C0',
    cardBackground: '#FFFFFF',
    cardShadow: '0 1px 3px rgba(13,71,161,0.2)',
    cardOverlayGradient: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
    cardOverlayTextColor: '#FFFFFF',
    favoriteColor: '#FF4081',
  },
  green: {
    accentColor: '#43A047',
    backgroundColor: '#E8F5E9',
    textColor: '#1B5E20',
    titleColor: '#2E7D32',
    subtitleColor: '#388E3C',
    buttonColor: '#43A047',
    iconColor: '#1B5E20',
    headerBackground: 'rgba(67,160,71,0.1)',
    headerShadow: '0 2px 4px rgba(27,94,32,0.1)',
    titleGradient: 'linear-gradient(45deg, #43A047, #81C784)',
    dividerColor: '#43A047',
    menuBackground: '#FFFFFF',
    menuTextColor: '#1B5E20',
    menuItemColor: '#2E7D32',
    cardBackground: '#FFFFFF',
    cardShadow: '0 1px 3px rgba(27,94,32,0.2)',
    cardOverlayGradient: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
    cardOverlayTextColor: '#FFFFFF',
    favoriteColor: '#FF4081',
  },
  yellow: {
    accentColor: '#FBC02D',
    backgroundColor: '#FFFDE7',
    textColor: '#F57F17',
    titleColor: '#F9A825',
    subtitleColor: '#FBC02D',
    buttonColor: '#FBC02D',
    iconColor: '#F57F17',
    headerBackground: 'rgba(251,192,45,0.1)',
    headerShadow: '0 2px 4px rgba(245,127,23,0.1)',
    titleGradient: 'linear-gradient(45deg, #FBC02D, #FFF176)',
    dividerColor: '#FBC02D',
    menuBackground: '#FFFFFF',
    menuTextColor: '#F57F17',
    menuItemColor: '#F9A825',
    cardBackground: '#FFFFFF',
    cardShadow: '0 1px 3px rgba(245,127,23,0.2)',
    cardOverlayGradient: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
    cardOverlayTextColor: '#FFFFFF',
    favoriteColor: '#F57F17',
  },
  pink: {
    accentColor: '#EC407A',
    backgroundColor: '#FCE4EC',
    textColor: '#880E4F',
    titleColor: '#C2185B',
    subtitleColor: '#D81B60',
    buttonColor: '#EC407A',
    iconColor: '#880E4F',
    headerBackground: 'rgba(236,64,122,0.1)',
    headerShadow: '0 2px 4px rgba(136,14,79,0.1)',
    titleGradient: 'linear-gradient(45deg, #EC407A, #F48FB1)',
    dividerColor: '#EC407A',
    menuBackground: '#FFFFFF',
    menuTextColor: '#880E4F',
    menuItemColor: '#C2185B',
    cardBackground: '#FFFFFF',
    cardShadow: '0 1px 3px rgba(136,14,79,0.2)',
    cardOverlayGradient: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
    cardOverlayTextColor: '#FFFFFF',
    favoriteColor: '#880E4F',
  },
  minimalist: {
    accentColor: '#C4A484',
    backgroundColor: '#FFFFFF',
    textColor: '#212121',
    titleColor: '#212121',
    subtitleColor: '#757575',
    buttonColor: '#212121',
    iconColor: '#212121',
    headerBackground: 'rgba(33,33,33,0.05)',
    headerShadow: '0 1px 2px rgba(0,0,0,0.1)',
    titleGradient: 'none',
    dividerColor: '#E0E0E0',
    menuBackground: '#FFFFFF',
    menuTextColor: '#212121',
    menuItemColor: '#212121',
    cardBackground: '#FFFFFF',
    cardShadow: '0 1px 2px rgba(0,0,0,0.1)',
    cardOverlayGradient: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
    cardOverlayTextColor: '#FFFFFF',
    favoriteColor: '#FF4081',
  },
};

export const applyTheme = (theme: ThemeType) => {
  return themeConfigs[theme];
};